import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import procenaRizikaImg from "../../../../../picture/sredstva-oprema.png";
import MasineIUredjajiPocetna from "./MasineIUredjajiPocetna";
import ElektroOpremaPocetna from "../show-bar-elektro-oprema/ElektroOpremaPocetna";
import KolektivnaOpremaPocetna from "../show-bar-kolektivna-oprema/KolektivnaOpremaPocetna";
import OstalaOpremaPocetna from "../show-bar-ostala-dokumenta/OstalaOpremaPocetna";
import ShowBarLZO from "./ShowBarLzo";

const obrazci = [
  "ЛИЧНА ЗАШТИТНА ОПРЕМА",
  "МАШИНЕ, УРЕЂАЈИ И АЛАТИ",
  "ПРЕВОЗНА СРЕДСТВА И МЕХАНИЗАЦИЈА",
  "ЕЛЕКТРО ОПРЕМА И ИНСТАЛАЦИЈЕ",
  "КОЛЕКТИВНА ОПРЕМА",
  "СРЕДСТВА ЗА ПРУЖАЊЕ ПРВЕ ПОМОЋИ",
  "ОСТАЛА СРЕДСТВА И ОПРЕМА ЗА РАД",
  "ПРОЦЕСНИ МАТЕРИЈАЛИ"
];

function ShowBarSredstvaOprema() {
  const {
    selectedSredstvaOprema,
    setSelectedSredstvaOprema,
    setIsLZOClicked,
    folderDokumentCurrentState
  } = useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedSredstvaOprema !== index + 1) {
      setSelectedSredstvaOprema(index + 1);
    } else {
      setSelectedSredstvaOprema(0);
    }
    if (index === 0) setIsLZOClicked(true);
  };

  // Kad je otvoreno dodavanje iz kataloga, prikaži stablo kategorija
  if (selectedSredstvaOprema === 1 && folderDokumentCurrentState === "DODAVANJE_POSTOJECI") {
    return <ShowBarLZO />;
  }

  return (
    <div style={{ backgroundColor: "white" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center", padding: "10px" }}>
        <img src={procenaRizikaImg} style={{ width: "40%" }} />
      </div>

      {selectedSredstvaOprema === 2 ? (
        <MasineIUredjajiPocetna />
      ) : selectedSredstvaOprema === 4 ? (
        <ElektroOpremaPocetna />
      ) : selectedSredstvaOprema === 5 ? (
        <KolektivnaOpremaPocetna />
      ) : selectedSredstvaOprema === 7 ? (
        <OstalaOpremaPocetna />
      ) : (
        <div style={{ height: "500px", overflowY: "auto" }}>
          {obrazci.map((obrazac, i) => (
            <div onClick={() => handleClickObrazac(i)} key={i}>
              <Button
                active={selectedSredstvaOprema === i + 1}
                style={{
                  padding: "7px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minHeight: "64px",
                  display: "block",
                  fontSize: "16px"
                }}
              >
                {obrazac}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ShowBarSredstvaOprema;